function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5a7a7d;stroke-linecap:round;stroke-linejoin:round;stroke-width:50px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M131.8,579.82l-103-343.21A67.72,67.72,0,0,1,70,150.45l13.41-4.72a67.67,67.67,0,0,1,86.15,41.18L277.08,497.37"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M437,514.42,414.61,91.6A67.72,67.72,0,0,0,346.18,25L332,25.2a67.73,67.73,0,0,0-66.62,68.42l11.71,403.76"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M569,576.09l78.68-416.81a64.75,64.75,0,0,0-52.22-74.9L582.11,82a64.78,64.78,0,0,0-74.92,52.22L437,514.42"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M569.64,576,719.27,332.31a52.85,52.85,0,0,1,68.12-30.14l10.35,4a52.83,52.83,0,0,1,30.13,68.1l-114,271L673,892l-71,205.31"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M407.33,961.1c3-123.37-153.15-197.92-153.15-197.92l-9.52-37.75,128.66-47.7c33.33-20.8,42.24-61.72,26.57-100.28-12.26-30.22-46.39-22.93-46.39-22.93s-193.68,21.27-227.44,37.89c-72.49,35.67-44.29,209.74-23.51,264.53s95.51,222.52,95.51,222.52v39"
})));

function SvgLeft4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 856.39 1143.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft4);
export default __webpack_public_path__ + "static/media/left-4.91f2614d.svg";
export { ForwardRef as ReactComponent };